<template>
	<div :class="{ newsOverflow: expanded }">
		<div class="flex items-end justify-between w-full mb-4" v-if="!expanded">
			<h6 class="font-bold leading-normal text-md text-primary">News</h6>
			<h6 id="modalLink" class="text-xs font-bold leading-normal text-blue-800 underline cursor-pointer" @click="$emit('loadModal', null)">
				Full News Feed
			</h6>
		</div>
		<span id="noNewsFeed" class="px-4 py-3 text-primary" v-if="!newsList.length > 0">No unread news</span>
		<Card v-for="news in newsList" :key="news.id" class="container card">
			<template #title>
				<h2 class="p-card-title-font" style="margin-bottom: 0px">{{ news.headline }}</h2>
			</template>
			<template #subtitle>
				<div class="flex items-center justify-between w-full">
					{{ formatDate(news.releaseDate) + formatCreatedBy(news.createdByNavigation) }}
					<div v-tooltip.left="news.category.categoryName">
						<component :is="news.category.categoryIcon" class="mt-0" aria-hidden="true" style="width: 24px; height: 24px"></component>
					</div>
				</div>
			</template>
			<template #content>
				<div :class="{ imageFlex: expanded, flex: expanded, 'flex-row': expanded, 'gap-4': expanded }">
					<div
						v-html="news.newsContent"
						:class="{ contenttextclamp3: !expanded, 'p-card-content': !expanded, 'p-card-content-large': expanded }"
					></div>
					<div class="w-full text-right" v-if="!expanded">
						<a id="lnkReadMore" href="#" @click="$emit('loadModal', news.id)" class="text-primary hover:text-secondary hover:underline">Read More</a>
					</div>

					<div style="width: fit-content; max-width: 30%; text-align: right" v-if="expanded && news.imageFileUri">
						<div class="image">
							<img :src="news.imageFileUri" :ref="news.imageFileUri" />
							<div class="overlay">
								<span class="zoom-icon" @click="zoomImage(news.imageFileUri)">
									<FontAwesomeIcon style="color: #000000; width: 1.25em; height: 1.25em" icon="search-plus" />&nbsp; Click to Zoom
								</span>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Card>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { ApiClient, News } from "../../entities/NSwagGenerated"
import Card from "primevue/card"

import { SessionInfo, PageAccess } from "../auth/personSessionData"
import { AdjustmentsHorizontalIcon, AcademicCapIcon, SpeakerWaveIcon, ChartPieIcon, ExclamationCircleIcon } from "@heroicons/vue/24/outline"
import Tooltip from "primevue/tooltip"
import { library } from "@fortawesome/fontawesome-svg-core"
import {
	faUserSecret,
	faChevronDown,
	faChevronRight,
	faPencilAlt,
	faMinus,
	faEyeSlash,
	faPlus,
	faEdit,
	faMapMarkerAlt,
	faSearchPlus,
	faSearchMinus,
	faMapMarker,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

library.add(
	faUserSecret,
	faChevronRight,
	faChevronDown,
	faPencilAlt,
	faMinus,
	faEyeSlash,
	faPlus,
	faEdit,
	faMapMarkerAlt,
	faSearchPlus,
	faSearchMinus,
	faMapMarker
)

library.add(faUserSecret)

export default defineComponent({
	name: "newsFeed",
	directives: {
		tooltip: Tooltip,
	},
	data() {
		const apiClient = new ApiClient(import.meta.env.VITE_API_URL?.toString())

		const displayForm: boolean = false
		const news = new News()
		let newsId: string = ""
		let renderForm = true

		return {
			apiClient,
			displayForm,
			SessionInfo,
			PageAccess,
			renderForm,
		}
	},
	emits: ["loadModal", "zoomParent"],
	components: {
		Card,
		AdjustmentsHorizontalIcon,
		AcademicCapIcon,
		SpeakerWaveIcon,
		ChartPieIcon,
		ExclamationCircleIcon,
		FontAwesomeIcon,
	},
	props: {
		newsList: {
			required: true,
		},
		expanded: {
			type: Boolean,
			required: true,
		},
	},
	methods: {
		zoomImage(imgFile: any) {
			this.$emit("zoomParent", imgFile)
		},
		formatCreatedBy(person) {
			if (person == null) {
				return ""
			} else {
				return " by " + person.firstName + " " + person.lastName
			}
		},
		formatDate(dateString) {
			const options = { year: "numeric", month: "long", day: "numeric" }
			return new Date(dateString).toLocaleDateString("en", options)
		},
	},
})
</script>

<style scss scoped>

.p-card {
	background: white;
}

div.p-card-body {
	padding: 0 !important;
}

.p-card-subtitle {
	font-size: 0.685rem;
	margin-bottom: 0;
}

::v-deep(.p-card-content) {
	font-size: 0.9rem;
	padding: 0 !important;
	margin: 0 !important;
	text-align: justify;
}

.p-card-content-large {
	font-size: 1rem;
	padding: 0 !important;
	text-align: justify;
}

.contenttextclamp3 {
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
}

.container {
	box-shadow: 4px 4px 4px #e7e4e4;
	border: solid 1px lightgrey;
	border-radius: 0.5em;
}

.imageFlex {
	display: flex;
	justify-content: flex-end;
}

.imageFlex > div:nth-child(1) {
	flex-basis: 100%;
	flex: 2;
}
.imageFlex > .card-image {
	flex-basis: 100%;
	flex: 1;
}
.imageFlex > .card-image > img {
	max-width: 97%;
	max-height: 97%;
	margin-left: auto;
	margin-top: 0.5rem;
	border: solid 1px rgb(41, 103, 175);
	z-index: 10000;
	border-radius: 1em;
}

/* .imageFlex > div:nth-child(2) > img:hover {
	transform: scale(1.5);
	position: absolute;
	z-index: 20000;
	cursor: pointer;
	top: 30%;
	left: 40%;
	max-width: 40%;
	max-height: 40%;
} */

.newsOverflow {
	overflow-y: auto !important;
	height: auto;
	max-height: 85vh;
}
.overlay {
	height: 100%;
	width: 100%;
	display: none;
	transition: 0.3s ease;
	background-color: #d1d1d1;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	position: absolute;
}
.image:hover .overlay {
	opacity: 0.89;
	display: block;
}
.zoom-icon {
	cursor: pointer;

	z-index: 5;
	position: absolute;
	color: black;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.image {
	position: relative;
	width: 100%;
}

.zoom-image {
	transform: scale(3);
	z-index: 999999;
	position: absolute;
	top: 20%;
	left: 20%;
	display: block;

	/* 
	
	cursor: pointer;
	top: 30%;
	left: 40%;
	max-width: 40%;
	max-height: 40%; */
}
</style>
